<template>
  <div class="repeat-white-page">
    <a-breadcrumb
      separator="/"
    >
      <a-breadcrumb-item>
        <!-- 项目配置 -->
        <router-link :to="{ name: `configIndex` }">
          {{ $t('message["1326"]') }}
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        <!-- 信息查重配置 -->
        <router-link :to="{ name: 'configRepeat' }">
          {{ $t('message["1357"]') }}
        </router-link>
      </a-breadcrumb-item>
      <!-- 编辑白名单 -->
      <a-breadcrumb-item>{{ $t('message["1906"]') }}</a-breadcrumb-item>
    </a-breadcrumb>
    <h1 class="title">
      {{ $t('message["1906"]') }}
    </h1>
    <!-- 提示：本列表中的信息将获得查重豁免权，检测到重复后也不会禁止保存 -->
    <a-alert
      type="warning"
      :message="$t('message[1907]')"
      show-icon
    />
    <a-form
      :form="form"
      class="table-wrap"
    >
      <table>
        <th>
          <td
            v-for="item in repeatFields"
            :key="item.key"
          >
            {{ item.fieldname }}
          </td>
          <!-- 备注 -->
          <td>{{ $t('message["27"]') }} </td>
          <!-- 操作 -->
          <td>
            {{ $t('message["79"]') }}
          </td>
        </th>
        <tr
          v-for="(item, i) in tableList"
          :key="item._id"
        >
          <td
            v-for="(one, j) in item.whitefields"
            :key="one.fieldkey"
          >
            <a-form-item>
              <a-input
                v-decorator="[`input.${i}.${j}`, {
                  validateTrigger: ['blur'],
                  rules: [{
                    validator: checkValue
                  }],
                  initialValue: one.fieldvalue
                }]"
                :placeholder="`${$t('message[1904]')}${one.fieldname}`"
                @input="handleInput($event, one.fieldkey, item, i, one, j)"
              />
            </a-form-item>
          </td>
          <td>
            <a-input
              :value="item.remarks"
              :placeholder="$t('message[1908]')"
              :max-length="20"
              @input="handleInput($event, 'remarks', item, i)"
            />
          </td>
          <td>
            <!-- 删除 -->
            <a
              class="del-btn"
              @click="handleDelete(item, i)"
            >{{ $t('message[962]') }}</a>
          </td>
        </tr>
        <tr>
          <td :colspan="repeatFields.length + 2">
            <!-- 新增字段 -->
            <a-button @click="handleAdd">
              <i class="iconfont iconicon-test10 fs-gray fz-12 m-r-4" /> {{ $t('message[1354]') }}
            </a-button>
          </td>
        </tr>
      </table>
    </a-form>
    <!-- 保存按钮 -->
    <div
      class="footer-wrap"
    >
      <div

        ref="footer"
        class="footer"
      >
        <a-button
          type="primary"
          :loading="submitting"
          @click="handleSubmit"
        >
          {{ $t('message["21"]') }}
        </a-button>
        <!-- 返回 -->
        <a-button
          @click="handleBack"
        >
          {{ $t('message["282"]') }}
        </a-button>
      </div>
    </div>
    <leave-tip-dialog
      ref="leaveTip"
      @leavelHandler="leavelHandler"
    >
      <div slot="tip-slot">
        {{ $t('message["1512"]') }}，<br>
        {{ $t('message["920"]') }}？
      </div>
    </leave-tip-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFooterStyle } from '@/lib/utils'
import LeaveTipDialog from '@/components/pc/LeaveTipDialog'

export default {
  components: {
    LeaveTipDialog
  },
  data () {
    return {
      form: this.$form.createForm(this),
      tableList: [],
      // isShowBtn: false,
      submitting: false,
      // 离开当前页面给出提示
      isBackObj: {
        status: false,
        count: 0,
        leave: {},
        hasSumbit: false
      }
    }
  },
  computed: {
    ...mapState('config/repeat', ['repeatFields', 'repeatWhiteList'])
  },
  watch: {
    repeatWhiteList: {
      handler (val) {
        if (!val) return
        this.tableList = val.map(item => {
          item._id = Math.random() * Math.pow(10, 18)
          return item
        })
      },
      immediate: true
    },
    tableList: {
      handler (val) {
        if (!val) return
        this.isBackObj.count++
        if (this.isBackObj.count > 1) {
          // this.isShowBtn = true
          setFooterStyle(this)
          this.removeClick()
          this.addClick()
        }
      },
      deep: true
    }
  },

  beforeRouteLeave (to, from, next) {
    if (this.isBackObj.count > 1 && !this.isBackObj.hasSumbit) {
      if (this.isBackObj.status) {
        this.removeClick()
        next()
        return
      }
      this.$refs.leaveTip.changeLimitDialog(true)
      this.isBackObj.leave = to
      next(false)
    } else {
      this.removeClick()
      next()
    }
  },
  created () {
    this.fetchRepeatData()
    this.getRepeatWhiteList()

    setFooterStyle(this)
    window.addEventListener('resize', () => {
      setFooterStyle(this)
    })
    document.addEventListener('scroll', () => {
      setFooterStyle(this)
    })
  },
  methods: {
    ...mapActions(['addClick', 'removeClick']),
    ...mapActions('config/repeat', ['fetchRepeatData', 'getRepeatWhiteList', 'setRepeatWhiteList']),
    handleInput (e, name, item, i, one, j) {
      let val = e.target.value
      item.whitefields[name] = val
      if (name !== 'remarks') {
        one.fieldvalue = val
        item.whitefields.splice(j, 1, one)
        this.$nextTick(() => {
          for (let index in item.whitefields) {
            this.form.setFieldsValue({
              [`input.${i}.${index}`]: item.whitefields[index].fieldvalue || ''
            })
          }
          this.form.setFieldsValue({
            [`input.${i}.${j}`]: val
          })
        })
      } else {
        if (this.$getZhStrlen(val) > 20) {
          val = this.$subZhStr(val, 20, false)
        }
        item.remarks = val
      }
    },

    handleAdd () {
      let whitefields = []
      for (let i in this.repeatFields) {
        const item = this.repeatFields[i]
        whitefields.push({
          fieldkey: item.fieldkey,
          fieldname: item.fieldname,
          fieldtype: item.fieldtype,
          fieldvalue: ''
        })
      }
      this.tableList.push({
        _id: Math.random() * Math.pow(10, 18),
        whitefields,
        remarks: ''
      })
    },
    handleDelete (item, i) {
      this.tableList.splice(i, 1)
    },
    async handleSubmit () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.submitting = true
          let config = this.tableList.map(item => {
            item.whitefields = item.whitefields.map(one => {
              one.fieldvalue = one.fieldvalue.trim()
              return one
            })
            return {
              id: item.id,
              remarks: item.remarks,
              whitefields: item.whitefields
            }
          })
          let chain = await this.setRepeatWhiteList({
            config
          })
          chain.onSuccess(res => {
            this.submitting = false
            this.isBackObj.count = 0
            // this.isShowBtn = false
          })
        }
      })
    },
    handleBack () {
      this.$router.push({
        name: 'configRepeat'
      })
    },
    checkValue (rule, value, callback) {
      const { field } = rule
      let arr = field.split('.')
      const i = arr[1]
      const j = arr[2]
      let currRow = this.tableList[i]
      let currColumn = currRow.whitefields[j]
      let { fieldtype } = currColumn || {}
      let msg = ''

      /* if (fieldtype === 'phone' && value) {
        if (!/^[1][0,3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
          msg = '不是有效的手机格式'
          callback(msg)
        } else {
          callback()
        }
      } */
      if (fieldtype === 'email' && value) {
        if (!/^[A-Za-z\d0-9]+([-_.][A-Za-z\d0-9]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,64}$/.test(value)) {
          // 不是有效的邮箱格式
          msg = this.$t('message["1909"]')
          callback(msg)
        } else {
          callback()
        }
      }
      let emptyFilter = currRow.whitefields.filter(item => item.fieldvalue === '')
      if (emptyFilter.length === currRow.whitefields.length) {
        // 每行必须有一个不能为空
        msg = this.$t('message["1910"]')
        callback(msg)
      } else {
        callback()
      }
      callback()
    },
    leavelHandler (b) {
      const { leave } = this.isBackObj
      if (b) {
        this.isBackObj.status = true
        this.isBackObj.count = 0
        this.$router.push({ name: leave.name, query: leave.query, params: leave.params })
      } else {
        this.isBackObj.status = false
      }
      this.$refs.leaveTip.changeLimitDialog(false)
    }
  }
}
</script>

<style scoped lang="scss">
.repeat-white-page {
  .ant-breadcrumb {
    padding-top: 16px;
  }
  h1.title {
    margin: 0 0 24px;
  }
  .table-wrap {
    overflow-y: scroll;
  }
  table {
    width: 100%;
    margin-top: 24px;
    th,tr {
      display: table-row;
    }
    th {
      height: 48px;
      line-height: 48px;
      font-weight: bold;
      background: #F5F6F7;
    }
    tr {
      background-color: #fff;
      border-bottom: solid 1px #ebebeb;
    }
    tr td {
      height: 64px;
      line-height: 64px;
      vertical-align: middle;
    }
    td {
      padding: 0 16px;
    }
    .ant-form-item::v-deep {
      margin-bottom: 0;
    }
    .ant-input::v-deep {
      width: 160px;
    }
    .del-btn {
      display: block;
      width: 100px;
    }
  }
}
.footer-wrap {
  height: 64px;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 64px;;
  z-index: 999;
  margin-left: -40px;
  padding: 16px 44px;
  background-color: #fff;
  border-top: solid 1px $gray4;
  transition: bottom 0.5s linear;
}
</style>
